
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Tempotravellerrentinpune() {



    const cardData =
    {
        keyword: ' Tempo Traveller Rent in Pune',
        heading: 'Samarth Travels:  Tempo Traveller Rent in Pune',
        headingDescription: 'Samarth Travels offers reliable and affordable Tempo Traveller rentals in Pune, ideal for group outings, corporate events, or family trips. Choose from a range of well-maintained vehicles, including 12-seater and 13-seater options, all equipped with comfortable seating and essential amenities. With transparent pricing, no hidden charges, and a commitment to punctuality and customer satisfaction, Samarth Travels ensures a smooth and enjoyable travel experience across Pune and beyond.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

        "topPlaces": [
             {
                "title": "Sinhagad Fort",
                "description": "Perched atop the Sahyadri hills, Sinhagad Fort is a historic hill fortress located about 30 kilometers from Pune. Famous for the Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers breathtaking views, trekking trails, and remnants of ancient military architecture including bastions, gates, and memorials. It's an ideal destination for trekking enthusiasts, history buffs, and nature lovers alike."
            },
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada is one of Pune's most iconic landmarks and a symbol of the Maratha Empire. Built in 1732 as the seat of the Peshwas, this grand fortification features majestic gates, elegant fountains, and intricate architecture. Although much of it was destroyed by fire in 1828, its massive stone walls and legendary tales—especially those surrounding the ghost of Narayanrao—still attract thousands of history lovers and tourists each year."
            },
            {
                "title": "Aga Khan Palace",
                "description": "The Aga Khan Palace is a stunning historical monument built in 1892 by Sultan Aga Khan III. It holds immense national significance due to its association with Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters who were imprisoned here during the Quit India Movement. Set in lush green gardens, the palace showcases Italian arches and spacious halls and also houses a museum with photographs, paintings, and personal belongings of Gandhi, making it a must-visit for those interested in India’s independence movement."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "The Pataleshwar Cave Temple is a unique 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single massive basalt rock, this ancient temple is a fine example of monolithic architecture from the Rashtrakuta period. Its main sanctum houses a linga, and the surrounding sanctum sanctorum includes statues of other deities. Despite being in the middle of the bustling city, it offers a tranquil and spiritual atmosphere for visitors."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "This revered Ganesh temple is one of the most visited and richly adorned temples in Maharashtra. Established by a sweet-maker named Dagdusheth Halwai in the late 19th century, the temple is known for its magnificent idol of Lord Ganesh decked in gold and diamonds. The temple draws massive crowds during the Ganesh Chaturthi festival, and its serene ambiance makes it a spiritual haven throughout the year."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This museum is a treasure trove of Indian heritage and folk art, established by Dr. Dinkar Kelkar in memory of his son. It houses over 20,000 rare and artistic artifacts, including musical instruments, sculptures, paintings, utensils, weaponry, and textiles from all over India. The collection gives a vivid picture of everyday life in bygone eras and is especially appealing to art enthusiasts and cultural historians."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Rising 2,100 feet above sea level, Parvati Hill offers panoramic views of Pune city. The hilltop temple complex consists of five main temples, including the Devdeveshwar temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa rule, it is not only a religious site but also a peaceful escape from the city buzz. A climb of 103 stone steps leads to the summit, where history and nature meet."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in the serene Koregaon Park area, the Osho International Meditation Resort is a tranquil oasis for seekers of inner peace and mindfulness. Founded by the spiritual guru Osho, it offers daily meditation sessions, yoga programs, and various wellness therapies in a luxurious, Zen-like environment. Visitors from all over the world come here for spiritual growth, rejuvenation, and to experience the calm ambiance of its lush gardens and modern facilities."
            },
            {
                "title": "Pune Okayama Friendship Garden",
                "description": "Also known as Pu La Deshpande Garden, this beautifully landscaped garden is inspired by Japan’s Okayama Korakuen Garden. Spread over 10 acres, it features artistically arranged lawns, water bodies, bridges, and pathways that create a harmonious blend of nature and design. It's a favorite among photography enthusiasts, families, and couples seeking a peaceful retreat amid nature."
            },
            {
                "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
                "description": "This combined facility includes a zoo, snake park, and a wildlife rescue center. The snake park is known for its wide variety of snakes, including the King Cobra and Indian Python, as well as informative exhibits on reptile behavior and conservation. The adjoining zoo is home to tigers, leopards, elephants, and other animals, making it an engaging educational and recreational spot, especially for children and families."
            }
        ],

   "services": [
    {
        "name": "Best Rates for Tempo Traveller Rent in Pune",
        "description": "Get the best rates on Tempo Traveller rentals in Pune with Samarth Travels. We offer competitive pricing across all vehicle types — from 12-seaters to 20-seaters — with no hidden charges. Whether for a short trip or multi-day travel, enjoy transparent, value-for-money packages with premium service."
    },
    {
        "name": "Cheap Tempo Traveller Rental Options in Pune",
        "description": "Looking for economical group travel? Samarth Travels offers cheap Tempo Traveller rental options in Pune without compromising on quality. Perfect for students, families, and small companies, our budget-friendly fleet is well-maintained and comes with trained, courteous drivers for a smooth ride."
    },
    {
        "name": "Luxury Tempo Traveller Rent Pune for Corporate Events",
        "description": "Make a strong impression at your next corporate event with a luxury Tempo Traveller rental from Samarth Travels. Featuring comfortable reclining seats, air conditioning, entertainment systems, and spacious interiors, our premium vehicles are ideal for executive travel, team outings, and VIP transfers."
    },
    {
        "name": "Pune to Shirdi Tempo Traveller Rental",
        "description": "Planning a pilgrimage to Shirdi? Rent a Tempo Traveller from Pune to Shirdi with Samarth Travels for a peaceful and safe journey. Our drivers are experienced on this route, and our comfortable, well-equipped vehicles make your spiritual trip convenient, whether for small families or large groups."
    },
    {
        "name": "12-Seater Tempo Traveller for Rent in Pune",
        "description": "Samarth Travels offers 12-seater Tempo Travellers in Pune, ideal for small group travel, airport transfers, corporate visits, or local sightseeing. Enjoy the perfect combination of space, comfort, and cost-efficiency with flexible rental options and fully air-conditioned vehicles."
    },
    {
        "name": "Rent a Tempo Traveller for Family Outings in Pune",
        "description": "Turn your family outing into a relaxed and enjoyable experience with a Tempo Traveller rental from Samarth Travels. Whether it’s a day trip to Lonavala, a weekend getaway, or a religious visit, our vehicles are designed for comfort and safety, accommodating all ages with ease."
    },
    {
        "name": "Hire a Tempo Traveller for Airport Transfers in Pune",
        "description": "Need reliable group transportation to or from Pune Airport? Hire a Tempo Traveller from Samarth Travels for stress-free airport transfers. Ideal for corporate guests, wedding parties, or family travel, our services guarantee punctual pickups, comfortable seating, and seamless coordination."
    }
],
"tableData": [
    ["Best Rates for Tempo Traveller Rent in Pune", "Cheap Tempo Traveller Rental Options in Pune"],
    ["Luxury Tempo Traveller Rent Pune for Corporate Events", "Pune to Shirdi Tempo Traveller Rental"],
    ["12-Seater Tempo Traveller for Rent in Pune", "Rent a Tempo Traveller for Family Outings in Pune"],
    ["Hire a Tempo Traveller for Airport Transfers in Pune", ""]
],


   "whychoose": [
    {
        "WhyChooseheading": "Top Choice for Tempo Traveller Rent in Pune",
        "WhyChoosedescription": "Samarth Travels is your go-to provider for Tempo Traveller rent in Pune, offering safe, reliable, and comfortable transportation for family trips, corporate travel, weddings, or group tours. With a reputation built on customer satisfaction, we ensure that your journey is hassle-free and enjoyable, no matter the occasion."
    },
    {
        "WhyChooseheading": "Spacious, Comfortable, and Well-Equipped Vehicles",
        "WhyChoosedescription": "Our Tempo Travellers come in a variety of sizes, ranging from 9-seater to 26-seater options, allowing you to choose the perfect vehicle for your group. All vehicles are air-conditioned, equipped with push-back seats, and designed with ample legroom for a relaxed travel experience, whether you're traveling across Pune or going on a longer journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers at Your Service",
        "WhyChoosedescription": "Our drivers are well-trained, courteous, and well-versed with the roads of Pune and surrounding areas. They ensure your safety by adhering to traffic rules and providing timely service, all while making your ride smooth and comfortable. They are also knowledgeable about popular tourist destinations and local routes, offering helpful insights along the way."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "We offer competitive pricing for Tempo Traveller rent in Pune, ensuring that you get great value for your money. Our rates are upfront and clear, with no hidden charges or last-minute surprises. The price you see is the price you pay, offering you complete transparency and confidence when booking with us."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Booking",
        "WhyChoosedescription": "Whether you need a Tempo Traveller in the early morning, late at night, or on short notice, Samarth Travels has you covered. Our vehicles are available round-the-clock to accommodate your travel schedule, making us the most reliable choice for any time of the day or night."
    },
    {
        "WhyChooseheading": "Easy Booking Process and Live Tracking",
        "WhyChoosedescription": "Booking your Tempo Traveller with Samarth Travels is quick and easy. You can book online via our website or speak directly with our customer support team. Once your booking is confirmed, we provide live tracking of your vehicle, real-time updates, and driver contact details to ensure you're always in the loop throughout your journey."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Safe Vehicles",
        "WhyChoosedescription": "Your safety and comfort are our top priorities. All our Tempo Travellers are thoroughly sanitized after each trip to ensure a clean and safe environment. Regular vehicle maintenance checks are conducted, and hygiene protocols are strictly followed, giving you peace of mind as you travel."
    },
    {
        "WhyChooseheading": "Flexible Payment Methods for Your Convenience",
        "WhyChoosedescription": "We offer multiple payment options to make your booking process seamless. Choose from cash, UPI, credit/debit cards, or digital wallets. Our flexible payment methods ensure that you can easily pay for your Tempo Traveller rental in Pune in a way that suits you best."
    }
]














    }

const faqData = [
    {
        id: 1,
        question: 'How can I get a Tempo Traveller on rent in Pune with Samarth Travels?',
        answer: 'To rent a Tempo Traveller in Pune, simply visit the Samarth Travels website or contact our customer support team. Share your travel details such as destination, number of passengers, and travel dates, and we’ll provide the best-suited vehicle at competitive rates.',
    },
    {
        id: 2,
        question: 'What seating capacities are available for Tempo Traveller rentals in Pune?',
        answer: 'Samarth Travels offers a variety of Tempo Travellers in Pune, including 9-seater, 12-seater, 17-seater, and 20-seater options. All are ideal for group travel, family functions, corporate outings, or school trips.',
    },
    {
        id: 3,
        question: 'What’s included in the Tempo Traveller rent in Pune?',
        answer: 'Our rental includes the cost of the vehicle, fuel, driver charges, and applicable taxes. We maintain full transparency, and any tolls, parking, or permit fees (if required) are communicated before the trip.',
    },
    {
        id: 4,
        question: 'Do you provide Tempo Travellers for outstation trips from Pune?',
        answer: 'Yes, we offer Tempo Traveller rentals for both local and outstation journeys. Popular outstation destinations include Mahabaleshwar, Lonavala, Shirdi, Goa, and more.',
    },
    {
        id: 5,
        question: 'Can I rent a Tempo Traveller in Pune for just one day?',
        answer: 'Absolutely. Samarth Travels offers flexible rental packages, including single-day hires, weekend trips, and extended tours. We tailor the service to meet your specific itinerary.',
    },
    {
        id: 6,
        question: 'Are the Tempo Travellers air-conditioned and comfortable?',
        answer: 'Yes, all our Tempo Travellers are fully air-conditioned and feature pushback seats, spacious legroom, and clean interiors for a safe and comfortable journey.',
    },
    {
        id: 7,
        question: 'Is 24/7 service available for Tempo Traveller rentals in Pune?',
        answer: 'Yes, we provide round-the-clock rental services. Whether you need an early morning departure or a late-night pickup, Samarth Travels is ready to serve you anytime.',
    },
];

const testimonials = [
    {
        name: 'Mr. Nilesh Pawar',
        role: 'Marketing Manager',
        text: 'We booked a 17-seater Tempo Traveller from Samarth Travels for a team outing. The vehicle was very comfortable and the service was excellent. On-time pickup and polite driver!',
        image: '/img/testimonial/testi_2_10.jpg',
    },
    {
        name: 'Miss. Prachi Desai',
        role: 'Yoga Instructor',
        text: 'Rented a 12-seater Tempo Traveller for a wellness retreat near Pune. Clean vehicle, smooth booking process, and professional staff. Will definitely use Samarth Travels again.',
        image: '/img/testimonial/testi_2_11.jpg',
    },
];















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Rent in Pune",
  "image": "https://samarthtravels.com/assets/images/tempo-traveller-rent-pune.jpg",
  "description": "Rent a Tempo Traveller in Pune at the best rates for family outings, corporate events, Shirdi trips, airport transfers, and more. Choose from budget-friendly to luxury options, including 12-seater and other models with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6124"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/tempo-traveller-rent-in-pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Tempo Traveller Rent in Pune | Best Rates & Luxury Options | Samarth Travels</title>
  <meta 
    name="description" 
    content="Find the best rates for Tempo Traveller rent in Pune. Rent affordable or luxury Tempo Travellers for family outings, corporate events, Shirdi trips, and airport transfers with Samarth Travels." 
  />
  <meta 
    name="keywords" 
    content="Best Rates for Tempo Traveller Rent in Pune, Cheap Tempo Traveller Rental Options in Pune, Luxury Tempo Traveller Rent Pune for Corporate Events, Pune to Shirdi Tempo Traveller Rental, 12-Seater Tempo Traveller for Rent in Pune, Rent a Tempo Traveller for Family Outings in Pune, Hire a Tempo Traveller for Airport Transfers in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravellerrentinpune;